module.exports = __webpack_public_path__ + "static/home1-2c89d41d3af2469e24474f472c6b7d04.jpg";